import React from 'react';

// import components
import LogoCarousel, { LogoCarouselSlide } from 'components/partials/logo-carousel';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

// import types
import { SvgLogoImage } from "types/svg-logo-image";

const SponsorsCarouselBuilder: React.FC<{ sponsorsCarouselData?: Queries.SponsorsCarouselBlockFragment }> = ({ sponsorsCarouselData }) => {

    if (!sponsorsCarouselData) return null;

    const slides = sponsorsCarouselData.sponsors?.map((sponsor): LogoCarouselSlide | undefined => {

        if (!sponsor) return undefined;

        let svgLogo: SvgLogoImage | undefined = undefined;

        // check svgLogo first
        if (sponsor.svgLogo?.url) {
            svgLogo = {
                url: sponsor.svgLogo.url,
                alt: sponsor.svgLogo.alt || '',
                height: sponsor.svgLogo.height || undefined,
                width: sponsor.svgLogo.width || undefined
            };
        }

        let image = undefined;
        let alt = "";

        if (!image && sponsor.image && isGatsbyImageData(sponsor.image.gatsbyImageData)) {
            image = sponsor.image?.gatsbyImageData;
            alt = sponsor.image?.alt ?? '';
        }

        return {
            image: image,
            svgLogoImage: svgLogo,
            url: sponsor.sponsorUrl ?? '',
            alt: alt
        };

    }).filter((slide): slide is LogoCarouselSlide => slide !== undefined) || [];

    return (
        <LogoCarousel
            headline={sponsorsCarouselData.heading ?? ''}
            slides={slides}
        />
    );
}

export default SponsorsCarouselBuilder;